import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const isProduction = process.env.NODE_ENV === 'production';

const supportedLngs = [
    "ak", "am", "ar", "ay", "be", "ber", "bm", "bn", "de", "en", "es", "ff", "fr", "gi", "gn",
    "gr", "gu", "ha", "hi", "ht", "id", "ig", "it", "ja", "ki", "km", "kn", "ko", "lg", "mg",
    "ml", "mr", "ne", "nl", "om", "pa", "pl", "ps", "pt", "qu", "ru", "sn", "so", "sw", "ta",
    "te", "th", "ti", "tr", "ur", "vi", "wo", "xh", "yo", "zh-Hans", "zh-Hant", "zu"
];

i18n
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs,
        fallbackLng: 'en',
        load: 'languageOnly',
        debug: !isProduction,

        interpolation: { escapeValue: false },

        ns: [
            'translation',
            'Sidebardash',
            'Exploredash',
            'PropertyCard',
            'Homedash',
            'PropertyModal',
            'Auth',
            'CommentPanel',
            'ForgotPassword',
            'Layout',
            'Login',
            'Messages',
            'MyListingDashboard',
            'Profiledash',
            'ResetPassword',
            'ShareModal',
            'Signup',
            'SmartTime',
            'Uploaddash',
            'Userprofiledash',
            'About',
            'translation'
        ],
        defaultNS: 'translation',

        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',

            saveMissing: false,
            missingKeyHandler: isProduction ?
                null :
                (lng, ns, key) => {
                    console.warn(`Missing key [${ns}]: ${key}`);
                },
            parse: (data, language, namespace) => {
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (!isProduction) {
                        console.error(`Failed to parse ${namespace} for ${language}:`, e);
                    }
                    return {};
                }
            }
        },
        detection: {
            order: ['localStorage', 'cookie', 'navigator'],
            caches: ['localStorage', 'cookie'],
            lookupLocalStorage: 'language',
            lookupCookie: 'language'
        },

        react: {
            useSuspense: false,
        }
    });

export default i18n;